import { tripsTabSagaWatcher, unloadingTripsTabSagaWatcher } from './containers/TripsTabContainer/saga';
import { tripSagaWatcher } from './containers/TripContainer/services/saga';
import { reportsSaga } from './reports/reportsSaga';
import { reportSagaWatcher } from './containers/ReportsContainer/services/saga';

export const securityModuleSaga = [
  tripsTabSagaWatcher,
  unloadingTripsTabSagaWatcher,
  tripSagaWatcher,
  reportSagaWatcher,
  ...reportsSaga,
];
